import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import B2CAdminSideBar from '../Components/B2CAdminSideBar';
import PrivateContentLayout from '../../Platform/Common/PrivateContentLayout';
import B2CQsetCategoryManager from '../Admin/B2CQsetCategoryManager';
import B2CQsetManager from '../Admin/B2CQsetManager';
import B2CReviewQset from '../Admin/B2CReviewQset';
import B2CProductManager from '../Admin/B2CProductManager';
import B2CDomainManager from '../Admin/B2CDomainManager';
import B2CCategoryManager from '../Admin/B2CCategoryManager';
import B2COfferManager from '../Admin/B2COfferManager';
import B2CReviewOffer from '../Admin/B2CReviewOffer';
import B2CReviewDomain from '../Admin/B2CReviewDomain';
import B2CReviewCategory from '../Admin/B2CReviewCategory';
import B2CReviewProduct from '../Admin/B2CReviewProduct';
import B2CExamManager from '../B2CExam Engine/AdminPages/B2CExamManager';
import ReviewB2CExam from '../B2CExam Engine/AdminPages/ReviewB2CExam';
import EvaluateB2CExamByAdmin from '../B2CExam Engine/AdminPages/EvaluateB2CExamByAdmin';
import AdminB2CExamScoreViewAttempt from '../B2CExam Engine/AdminPages/AdminB2CExamScoreViewAttempt';
import PracticeManualAttemptStatus from '../Practice Assessment Engine/AdminPages/PracticeManualAttemptStatus';
import EvaluatePracticeExamByAdmin from '../Practice Assessment Engine/AdminPages/EvaluatePracticeExamByAdmin';
import B2CAccountManagement from '../Admin/B2CAccountManagement';
import B2CReviewBlog from '../Admin/B2CReviewBlog';
import B2CBlogManager from '../Admin/B2CBlogManager';
import B2CReviewCoupon from '../Admin/B2CReviewCoupon';
import B2CCouponManager from '../Admin/B2CCouponManager';
import { StudentSidebarProvider } from '../Student/Layouts/StudentSidebarContext';
import StudentContentLayout from '../Student/Layouts/StudentContentLayout';
import StudentFooterLayout from '../Student/Layouts/StudentFooter';
import B2CReviewMasterPromotion from '../Admin/B2CReviewMasterPromotion';
import B2CStudentAttemptListings from '../Student/Pages-Route-Level/B2CStudentAttemptListings';
import PracticeAttemptDetailsViewer from '../Practice Assessment Engine/CommonPages/PracticeAttemptDetailsViewer';

const B2CAdminRouter = () => {


    return (

             <StudentSidebarProvider>
        <Box >
          {/* Sidebar with fixed width */}
            <B2CAdminSideBar />
             <StudentContentLayout >
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="question-set-manager" />} />

              <Route path="b2c-qset-category-manager" element={<B2CQsetCategoryManager />} />
              <Route path="b2c-qset-manager" element={<B2CQsetManager />} />
              <Route path="b2c-qset-manager/review-b2c-qset/:question_set_id" element={<B2CReviewQset />} />
              <Route path="b2c-product-manager" element={<B2CProductManager />} />
              <Route path="practice-manual-attempt" element={<PracticeManualAttemptStatus />} />
              <Route path="practice-manual-attempt/:practice_attempt_id/manual-score" element={<EvaluatePracticeExamByAdmin />} />
             {/*  <Route path="practice-manual-attempt/:practice_attempt_id/view" element={<PracticeAttemptDetailsViewer />} /> */}

             <Route path="practice-attempt/:practice_attempt_id/view"
  element={<PracticeAttemptDetailsViewer isAdminView />} />

              <Route path="b2c-product-manager/review-b2c-product/:product_id" element={<B2CReviewProduct />} /> 
              <Route path="b2c-category-manager" element={<B2CCategoryManager />} />
              <Route path="b2c-category/:category_id/review-category" element={<B2CReviewCategory />} />
              <Route path="b2c-category/:category_id/domains" element={<B2CDomainManager />} />
              <Route path="b2c-category/:category_id/review-domain/:domain_id" element={<B2CReviewDomain />} />    
              <Route path="b2c-category/:category_id/domain/:domain_id/offers" element={<B2COfferManager />} />
              <Route path="b2c-domain/:domain_id/review-offer/:offer_id" element={<B2CReviewOffer />} />        

              <Route path="b2c-account-manager" element={<B2CAccountManagement />} />   

              <Route path="b2cexam-manager" element={<B2CExamManager />} />
              <Route path="b2cexam-manager/review-b2cexam/:exam_id" element={<ReviewB2CExam />} />
              <Route path="b2cexam-manager/review-b2cexam/:exam_id/override/:exam_attempt_id" element={<EvaluateB2CExamByAdmin />} />
              <Route path="b2cexam-manager/review-b2cexam/:exam_id/score/:exam_attempt_id" element={<AdminB2CExamScoreViewAttempt />} />

              <Route path="b2c-blog-manager" element={<B2CBlogManager />} />
              <Route path="b2c-blog-manager/:blog_id/review-blog" element={<B2CReviewBlog />} />

              <Route path="b2c-coupon-manager" element={<B2CCouponManager />} />
              <Route path="b2c-coupon-manager/:coupon_id/review-coupon" element={<B2CReviewCoupon />} />
              <Route path="b2c-master-promotion" element={<B2CReviewMasterPromotion />} />
              <Route path="b2c-account-manager/entitlement/:entitlement_id/attempts"
                element={<B2CStudentAttemptListings isAdminView />} />
              
            </Routes>
          </Box>
          </StudentContentLayout>
           <StudentFooterLayout/>
      </Box>
      </StudentSidebarProvider>
    );
  };

export default B2CAdminRouter;
